<section class="series-authors details">
        <!-- <div class="heading-1 pb-5 text-gold text-center h4" data-aos="fade-in" data-aos-duration="1000">OUR INSTRUCTORS</div> -->
        <div class="feature-box">
            <div class="instructor-box d-flex align-items-center bg-series-author" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll" [style]="getStyles(sereisdetail)">
                <img *ngIf="sereisdetail" src="{{getInstructorThumbUrl(sereisdetail.image)}}">
                <div class="content-box">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="left-content" *ngIf="sereisdetail">
                                <h2 class="text-uppercase text-gold2">{{sereisdetail.name}}</h2>
                                <h3 class="text-white ft-wght-300">{{sereisdetail.title}}</h3>
                                <div class="chapter-details mt-5">
                                    <div class="icon-box">
                                        <i class="fas fa-video"></i>
                                    </div>
                                    <div class="details-box">
                                        <div class="text-white" *ngIf="series">{{series.length}} Chapters</div>
                                        <!-- <small class="text-gold">2.5 hours</small> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            
            
        </div>
</section>

<section class="seriesview">

    <div class="container py-5">
        <div class="row">
            <div class="col-12 col-sm-8">
                <div class="video-modal main">
                    <div class="main-content">
                        <ng-container *ngIf="videoDetails">
                            <video oncontextmenu="return false;" controlsList="nodownload" #videoFileContainer style="width: 100%;" [poster]="getThumbUrl(videoDetails.video_thumb)" id="player" playsinline controls>
                                <source src="{{getVideoUrl(videoDetails.video_url)}}" type="video/mp4">
                            </video>
                        </ng-container>
                    </div>
                </div>

            </div>
            <div class="col-12 col-sm-4">
                <div class="playlist-sidebar pb-2" *ngIf="series && !noVideos">
                    <div class="top-title px-3 py-2">
                        <div>
                            PLAYLIST
                        </div>
                        <div class="text-muted">
                            {{series.length}} chapters
                        </div>
                        <hr class="text-gold2 mb-0">
                    </div>
                    <ul class="scrolldiv2">
                        <li *ngFor="let video of series, let i=index">
                            <div *ngIf="video" class="playlist-item" [ngClass]="index == i ? 'active' : ''" (click)="openDetails(video)">  
                                <img src={{getThumbUrl(video.video_thumb)}}/> 
                                <div class="video-description">
                                    <!-- <p class="heading mb-0">Chapter {{i+1}}</p> -->
                                    <p class="heading mb-0 fs-13">{{video?.name | uppercase}} </p>
                                    <small class="text-gold2 ft-wght-300">{{video?.cat | uppercase}}</small>
                                </div>
                                <div class="fav-btn">
                                    <i class="fa fa-heart ms-2" [ngClass]="video.fav>0?'text-red':''" *ngIf="webApi.isLoggedIn()" (click)="addToFav($event,video)"></i>
                                </div>
                            </div>  
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12">
                <div class="main-body p-3 bg-black px-sm-0" *ngIf="videoDetails">
                    <div class="d-flex flex-row">
                        <div
                            class="text-gold2 text-uppercase">
                            {{videoDetails.name}} <i class="fa fa-heart ms-2" [ngClass]="videoDetails.fav>0?'text-gold':''" *ngIf="webApi.isLoggedIn()" (click)="addToFav($event,videoDetails)"></i>
                        </div>
                    </div>
                    <p class="my-2 text-white ft-wght-300 font-mulish fs-13 light-grey-color" [innerHTML]="videoDetails.description"></p>
                    <div class="d-flex flex-row">
                        <div
                            class="text-gold2 text-uppercase">
                            Add your notes:
                        </div>
                    </div>
                    <textarea class="my-2" rows="4" style="width:100%; padding: 15px; background: #e7e7e7;" [(ngModel)]="notes"></textarea>
                    <div class="d-flex justify-content-end mt-3">
                        <button type="button" (click)="addNote()"class="btn btn-gold2 mt-2 ml-auto">Save Note <i *ngIf="formSubmitting"
                                class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
        

    </div>

</section>